$('.video').magnificPopup({
	type: 'iframe',
	callbacks: {
		open: function() {
			const _this = this;
			const iframe = document.querySelector('.mfp-content iframe');

			if (iframe) {
				iframe.addEventListener('load', function() {
					const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

					const videoElement = iframeDoc.querySelector('video');
					const videoUrl = _this.st.el.attr('href');
					trackVideo(videoElement, videoUrl);
				});
			} else {
				console.error("No iframe found");
			}
		}
	}
});

function trackVideo(videoElement, videoUrl) {
	// Track video started
	dataLayer.push({
		event: 'video_start',
		video_url: videoUrl
	});

	if (videoElement) {
		const milestones = [10, 25, 50, 75, 90];
		const milestonesReached = new Set();

		// Track video progress
		videoElement.addEventListener('timeupdate', () => {
			const currentTime = videoElement.currentTime;
			const duration = videoElement.duration;

			if (duration > 0) {
				const percentWatched = Math.floor((currentTime / duration) * 100);

				milestones.forEach((milestone) => {
					if (percentWatched >= milestone && !milestonesReached.has(milestone)) {
						milestonesReached.add(milestone);

						dataLayer.push({
							event: 'video_progress',
							video_url: videoUrl,
							video_percent: milestone,
							video_current_time: Math.floor(currentTime),
							video_duration: Math.floor(duration),
						});
					}
				});
			}
		});

		// Track video completion
		videoElement.addEventListener('ended', () => {
			dataLayer.push({
				event: 'video_complete',
				video_url: videoUrl
			});
		});
	} else {
		console.error("No video element found");
	}
}